<template>
  <popup
    v-model="visible"
    position="bottom"
    get-container="#app"
    @open="init"
    :style="{ height: '100vh' }"
  >
    <div class="productSort copy-data">
      <div class="header acea-row row-center-wrapper">
        <div class="acea-row row-between-wrapper input">
          <i class="iconfont icon-sousuo"></i>
          <input
            type="text"
            placeholder="点击搜索项目信息"
            @confirm="doSearch"
            confirm-type="search"
            name="searchFm.title"
            placeholder-class="placeholder"
          />
        </div>
      </div>
      <div class="main-panel">
        <div class="aside">
          <div
            class="item acea-row row-center-wrapper"
            :class="index == navActive ? 'on' : ''"
            v-for="(item, index) in cateList"
            :key="index"
            @click="switchCategory(index, item)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>

        <div class="conter">
          <scroll-view scroll-y="true" scroll-with-animation="true">
            <div class="list">
              <div
                class="item"
                v-for="(itemn, indexn) in goodsList"
                :key="indexn"
              >
                <div
                  class="picture"
                  :style="{
                    'background-color': itemn.mainImage ? 'none' : '#f7f7f7',
                  }"
                >
                  <img
                    :src="itemn.mainImage + '!tmb_130'"
                    v-if="itemn.mainImage"
                  />
                  <img
                    src="@assets/images/def_service.jpg"
                    class="no-pictrue"
                    v-else
                  />
                </div>
                <div class="info">
                  <div class="head">
                    <div class="title">{{ itemn.title }}</div>
                    <!-- <div class="time">时长：{{itemn.duration || 0}}分钟</div> -->
                  </div>
                  <div class="bottom">
                    <div class="money">￥{{ itemn.price }}</div>
                    <div
                      class="immediate"
                      v-if="countNum(itemn.id) === 0"
                      @click="addToCart(itemn)"
                    >
                      添加
                    </div>
                    <div class="oprate" v-else>
                      <span
                        class="btn iconfont icon-jianhao"
                        @click="reduceNum(itemn.id)"
                      ></span>
                      <span class="num">{{ countNum(itemn.id) }}</span>
                      <span
                        class="btn iconfont icon-jiahao"
                        @click="addToCart(itemn)"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </scroll-view>
        </div>
      </div>

      <div
        class="footer acea-row row-between-wrapper"
        v-if="cartList.length > 0"
      >
        <div class="cart-icon acea-row row-center-wrapper" @tap="toCart">
          <div class="image iconfont icon-caigou"></div>
          <div class="num" v-if="cartList.length > 0">
            {{ cartList.length }}
          </div>
        </div>
        <div class="money acea-row row-middle">
          <div class="num"><span class="icon">￥</span>{{ countmoney }}</div>
          <div class="btn" @click="createBill()">确定</div>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import { mapGetters } from "vuex";
import { Popup } from "vant";
import { add } from "@/utils/bc";
import { fetchCasecade, fetchGoods } from "@/api/shop.js";
export default {
  props: {
    visible:false
  },
  components: {
    Popup,
  },
  data() {
    return {
      goodsList: [],
      cartList: [],
      cateList: [],
      bill: {},
      navActive: 0,
      number: "",
      countmoney: 0,
      currentCate: null,
      currentGoods: {},
      searchFm: {},
      memberId: null,
      page: {
        pageNo: 1,
        pageSize: 50,
      },
      tabbarH: 0,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    init() {
      console.info("初始化pop", this.userInfo.shopId);
      this.getAllCategory();
    },
    fetchData() {
      let { pageNo, pageSize } = this.page;
      let { title } = this.searchFm;
      let query = { pageNo, pageSize, param: {} };

      if (title) {
        query.param.title = `%${title}%`;
      }
      if (this.currentCate) {
        query.param.categoryId = this.currentCate;
      }

      fetchGoods(this.userInfo.shopId, query).then((resp) => {
        this.page = resp.result;
        this.goodsList = resp.result.records;
      });
    },
    doSearch() {
      this.fetchData();
    },
    switchCategory(index, item, event) {
      this.navActive = index;
      this.currentCate = item.id;
      this.fetchData();
    },
    getAllCategory: function () {
      fetchCasecade(this.userInfo.shopId, 0).then((res) => {
        this.cateList = res.result || [];
        if (this.cateList.length > 0) {
          this.currentCate = this.cateList[0].id;
        }
        this.fetchData();
      });
    },
    fetchGoods(cid) {
      fetchGoods(this.userInfo.shopId, { categoryId: cid }).then((res) => {
        this.goodsList = res.result.records || [];
      });
    },
    addToCart(item) {
      let {
        id,
        title,
        companyId,
        shopId,
        duration,
        price,
        mainImage,
        categoryId,
        commissionType,
        commission,
        integral,
        useIntegral,
      } = item;
      let cartItem = {
        itemId: id,
        itemName: title,
        companyId,
        shopId,
        elapsed: duration,
        price,
        categoryId,
        itemPic: mainImage,
        num: 1,
        commissionType,
        commission,
        integral,
        useIntegral,
      };

      // console.info(item,'xxxxxx')
      this.$emit("done", cartItem);
      // this.cartList.push(cartItem)
      // this.currentGoods = item
      // this.countMoney()
    },
    reduceNum(id) {
      this.cartList.splice(
        this.cartList.findIndex((item) => item.id === id),
        1
      );
      this.countMoney();
    },
    countNum(id) {
      let goodsArray = this.cartList.filter((c) => c.itemId === id);
      return goodsArray.length;
    },
    countMoney() {
      let carmoney = 0;
      let array = this.cartList || [];
      for (let i = 0; i < array.length; i++) {
        carmoney = add(carmoney, array[i].price);
      }
      this.countmoney = carmoney;
    },
    toCart() {},
    goBack() {
      this.$emit("done", false);
    },
    createBill() {
      if (this.cartList.length == 0) {
        this.toast("选择服务项目！");
      } else {
        this.$emit("done", this.cartList);
        console.info(this.cartList, "xxxxxxxxxxxx");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.productSort .header {
  width: 100%;
  height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
}
.productSort .header .input {
  height: 30px;
  background-color: #f5f5f5;
  border-radius: 25px;
  box-sizing: border-box;
  padding: 0 18px;
}

.productSort .header .input .iconfont {
  font-size: 16px;
  color: #555;
}

.productSort .header .input .placeholder {
  color: #999;
}

.productSort .header .input input {
  font-size: 13px;
  height: 100%;
  width: 300px;
}
.main-panel {
  display: flex;
  height: calc(100vh - 50px);
}
.productSort .aside {
  width: 24%;
  background-color: #f7f7f7;
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
}

.productSort .aside .item {
  height: 50px;
  width: 100%;
  font-size: 13px;
  color: #424242;
}

.productSort .aside .item.on {
  background-color: #fff;
  border-left: 2px solid #fb528b;
  width: 100%;
  text-align: center;
  color: #fb528b;
  font-weight: bold;
}

.productSort .conter {
  flex: 1;
  padding: 0 7px;
  background-color: #fff;
}

.productSort .conter .listw {
  padding-top: 10px;
}

.productSort .conter .listw .title {
  height: 45px;
}

.productSort .conter .listw .title .line {
  width: 50px;
  height: 1px;
  background-color: #f0f0f0;
}

.productSort .conter .listw .title .name {
  font-size: 14px;
  color: #333;
  margin: 0 15px;
  font-weight: bold;
}

.productSort .conter .list {
  height: 100%;
}

.productSort .conter .list .item {
  margin-top: 13px;
  display: flex;
  margin-bottom: 13px;
  width: 100%;
  margin-top: 8px;
}

.productSort .conter .list .item .picture {
  width: 54px;
  height: 54px;
  border-radius: 5px;
  margin-right: 15px;
}

.productSort .conter .list .item .picture img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.productSort .conter .list .item .name {
  font-size: 12px;
  color: #333;
  height: 28px;
  line-height: 28px;
  width: 60px;
  text-align: center;
}

.list {
  .info {
    flex: 1;

    .head {
      display: flex;
      justify-content: space-between;

      .title {
        font-size: 14px;
        margin-bottom: 7px;
      }

      .time {
        font-size: 14px;
        color: #979797;
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      padding-right: 5px;
      align-items: center;
      width: 100%;

      .money {
        color: #fb528b;
        font-size: 14px;
      }

      .oprate {
        padding: 3px 0;
      }

      .immediate {
        font-size: 14px;
        width: 66px;
        color: #ffffff;
        padding: 3px 10px;
        border-radius: 50px;
        background-color: #fb528b;
        text-align: center;
      }

      .num {
        display: inline-block;
        width: 25px;
        font-size: 12px;
        text-align: center;
      }

      .btn {
        color: #fb528b;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  z-index: 101;
  padding: 0 15px;
  box-sizing: border-box;
  height: 50px;

  .cart-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #fb528b, #fb57b4);
    border-radius: 50%;
    position: relative;
    margin-top: -18px;

    .image {
      width: 32px;
      height: 32px;
      font-size: 29px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .num {
      background-color: #fd9d27;
      min-width: 6px;
      color: #fff;
      border-radius: 15px;
      position: absolute;
      right: -3px;
      top: -5px;
      font-size: 12px;
      padding: 0 5px;
      height: 18px;
      line-height: 18px;
    }
  }

  .money {
    color: #fb528b;
    font-size: 16px;

    .num {
      font-size: 21px;
      font-weight: 700;
      .icon {
        font-size: 16px;
      }
    }

    .btn {
      width: 100px;
      height: 35px;
      background: linear-gradient(147deg, #fb528b, #fb57b4);
      border-radius: 23px;
      line-height: 35px;
      text-align: center;
      color: #fff;
      margin-left: 12px;
    }
  }
}
</style>
